/**
 * Beta Event Tracker — Lightweight logging for V1 beta.
 * Tracks: activity_created, activity_joined, link_opened, qr_opened, error
 */

const API = process.env.REACT_APP_BACKEND_URL;

export async function trackEvent(eventType, metadata = {}) {
  try {
    const token = localStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    await fetch(`${API}/api/beta-ops/event`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ event_type: eventType, metadata }),
    });
  } catch {
    // Silent fail — tracking should never break the app
  }
}
